<template>
	<div style="position: relative;">
		<v-row class="expandable" :class="classes" ref="panel">
			<slot name="content"></slot>
		</v-row>	
		<p class="text-center" style="position: absolute; width: 100%; bottom: -35px">
			<v-btn fab color="green" dark large @click="expand"><v-icon large>{{icon}}</v-icon></v-btn>
		</p>
	</div>
</template>

<style type="text/css">
	.expandable {
        overflow-y: hidden;
        max-height: 350px;
    }
	.expandable.expanded {
        transition: max-height 0.8s linear;
        max-height: 1700px;
	}
	
</style>
<script>
	export default {
		name: "ExpandableGrid", 
		props: [],
		data: () => {
			return {
				classes: {
					expanded: false
				}
			}
		},
		computed: {
			icon(){
				if(this.classes.expanded ){
					return "mdi-chevron-up"
				}
				else{
					return "mdi-chevron-down"
				}
			}
		},
		methods: {
			expand(){
				this.classes.expanded = !this.classes.expanded;
			}
		}
	}
</script>